<ng-container [ngSwitch]="status">

    <label class="label label-success" *ngSwitchCase="LocalLoadStatus.COMPLETED" [i18n]="[{target: 'innerHTML', key: 'local-loads.status.completed'}]">
    </label>
    <label class="label label-warning" *ngSwitchCase="LocalLoadStatus.ON_GOING" [i18n]="[{target: 'innerHTML', key: 'local-loads.status.on-going'}]">
    </label>
    <label class="label label-primary" *ngSwitchCase="LocalLoadStatus.PLANNED" [i18n]="[{target: 'innerHTML', key: 'local-loads.status.planned'}]">
    </label>
    <label class="label label-danger" *ngSwitchDefault [i18n]="[{target: 'innerHTML', key: 'local-loads.status.unknown'}]">
    </label>

</ng-container>
